import styled from '@emotion/styled';
import {
  space, color, layout, flexbox, typography,
} from 'styled-system';

const Wrapper = styled('div')`
  display: flex;
  ${space}
  ${color}
  ${layout}
  ${flexbox}
  ${typography}
`;

export default Wrapper;
